export enum PublishRulesApproveTypeEnum {
  REQUIRED = 'REQUIRED',
  NON_REQUIRED = 'NON_REQUIRED',
  PROMPTLY = 'PROMPTLY',
}
